
const apiBase = "https://campflare.vay.co"


const getToken = () => {
    return localStorage.getItem("campflare_token")
}


const fetchWithToken = async (path) => {
    const token = getToken()

    const req = await fetch(`${apiBase}${path}`, {
        headers: {
            "authorization": token
        }
    })

    const res = await req.json()

    if (res.errorCode === 3) {
        logout()
        return
    }

    return res
}

export const sendCodeToLogin = async (input) => {
    const { email, first, last, company } = input

    await fetch(`https://campflare.vay.co/api/login?email=${email}&first=${first}&last=${last}&company=${company}`)
}

export const checkCodeAndLogin = async (email, code) => {
    const req = await fetch(`https://campflare.vay.co/api/validate?email=${email}&code=${code}`)

    const { token, apiKey } = await req.json()

    if (!token) {
        throw new Error("no token")
    }

    localStorage.setItem("campflare_token", token)

    if (apiKey) {
        return apiKey
    } else {
        window.location.href = "/platform"
    }
}

export const isLoggedIn = () => {
    const token = getToken()
    return token !== null
}

export const logout = () => {
    localStorage.removeItem("campflare_token")
    window.location.href = "/platform"
}

export const getAccountData = async () => {
    return await fetchWithToken("/api/account/get")
}

export const createNewApiKey = async () => {
    const { apiKey } = await fetchWithToken("/api/key/new")
    return apiKey
}

export const createNewWebhookKey = async () => {
    const { webhookSecret } =  await fetchWithToken("/api/webhook/secret/new")

    return webhookSecret
}

export const updateWebhookUrl = async (url) => {
    return await fetchWithToken(`/api/webhook/url/update?url=${url}`)
}
